import styled from 'styled-components';
import {BGImageCenter} from '../../../../../../globalVariables/GlobalVariables';
import {dFlexCenter, dFlexColumn, flexWrap} from '../../../../../../globalVariables/GlobalFlex';
import {getSpacing, getFontSize, getFontWeight, tokens} from '@tickchak/react-share/app';

export const container = styled.div`
    position: relative;
    width: 100%;
    ${dFlexColumn}
    gap: ${getSpacing('spaceXl')};
`;

export const sectionTitle = styled.h2`
    font-size: ${getFontSize('h3')};
`;

export const typesGrid = styled.div`
    ${dFlexCenter}
    ${flexWrap}
    gap: ${getSpacing('spaceXl')};
`;

export const badge = styled.div<{$disabled?: boolean}>`
    height: 32px;
    width: max-content;
    border-radius: 8px;
    background: ${tokens.color.brand.main};
    ${dFlexCenter}
    font-weight: ${getFontWeight('medium')};
    padding-inline: ${getSpacing('spaceSm')};
    ${p => p.$disabled && `
        background: ${tokens.color.brand.disabled};
    `}
`;

export const inputWrapper = styled.div`
    width: 100%;
    position: relative;
    ${dFlexCenter}
    gap: ${getSpacing('spaceSm')};
    margin-bottom: ${getSpacing('spaceLg')};
`;

export const inputIcon = styled.div<{$icon: string}>`
    width: 17px;
    height: 17px;
    ${p => BGImageCenter(p.$icon, '17px')}
`;

